module.exports = __webpack_public_path__ + "img/persona dreamdeal tech (3)-19.ac2c7657.jpg";